import { alpha, Theme } from '@mui/material/styles';

export default function Menu(theme: Theme) {
  const isDark = theme.palette.mode === 'dark';
  return {
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: theme.palette.background.paper,
          backgroundImage: 'none',
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 12,
          boxShadow: isDark ? '0 16px 40px rgba(0,0,0,0.45)' : '0 12px 32px rgba(15,26,46,0.12)',
        },
        list: {
          padding: 6,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          marginTop: 2,
          marginBottom: 2,
          transition: theme.transitions.create(['background-color', 'color']),
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
          },
          '&.Mui-focusVisible': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
          },
          '&.Mui-selected': {
            backgroundColor: alpha(theme.palette.primary.main, 0.16),
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.main, 0.22),
            },
            '&.Mui-focusVisible': {
              backgroundColor: alpha(theme.palette.primary.main, 0.22),
            },
          },
        },
      },
    },
  };
}
